import React from 'react';
import KeywordDetailSection from '../../../sections/AdminDashboard/Keywords/KeywordDetail';

const KeywordDetail = () => {
  return <KeywordDetailSection />;
};

export default KeywordDetail;
